import React from 'react';
export function ClosingSection() {
  return <section className="px-4 py-12" data-id="element-52">
      <div className="max-w-3xl mx-auto text-center" data-id="element-53">
        <h2 className="mb-4 text-3xl font-bold md:text-4xl text-brand-teal" data-id="element-54">
          Tu camino en el Tarot empieza hoy
        </h2>
        <p className="mb-6 text-xl text-brand-dark/80 leading-relaxed" data-id="element-55">
          Tenés la oportunidad de llevarte 6 guías y 3 bonus llenos de
          significados, tiradas y recursos listos para imprimir. Dejá de dudar
          de tu intuición y empezá a leer con confianza.
        </p>

        <div className="flex flex-col items-center gap-4" data-id="element-56">
          <p className="text-sm font-medium text-brand-dark/60" data-id="element-57">
            Garantía de 7 días • Pago único de $19.990 ARS
          </p>
          <p className="text-xs text-brand-dark/50 mt-2" data-id="element-58">
            Recordá: Producto digital en PDF no editable. No incluye
            actualizaciones futuras.
          </p>
        </div>
      </div>
    </section>;
}